module.exports = __webpack_public_path__ + "img/Hotel_Amnis.d09f376c.jpg";